export const ENDPOINTS = {
  BASE_URL: "https://jasser-back-production.up.railway.app",
};
